import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {normalize, concatMergeStrategy} from '../../util/utils';
import {HttpStatusCodes} from '../../util/uiconstants';
import Utility from '../../util/utilityfunctions';

const filterStatefunc = (trialBalance, includeArray) => {
	let types = trialBalance.financialStatementsTypes;
	let financialStatementIds = trialBalance.financialStatement;
	let filteredIds = [];

	for (let i = 0; i < financialStatementIds.length; i++) {
		let financialStatementId = financialStatementIds[i];
		let type = types.find((t) => t.id === financialStatementId)?.financialStatementTypeId;

		if (!includeArray.includes(type)) {
			filteredIds.push(financialStatementId);
		}
	}

	return {
		...trialBalance,
		financialStatements: filteredIds
	};
};

const filterTrialBalancesState = (trialBalances, includeArray) => {
	for (let i = 0; i < trialBalances.allIds.length; i++) {
		let trialBalanceId = trialBalances.allIds[i];

		trialBalances = {
			...trialBalances,
			byId: {
				...trialBalances.byId,
				[trialBalanceId]: filterStatefunc(trialBalances.byId[trialBalanceId], includeArray)
			}
		};
	}

	return trialBalances;
};

export function trialBalancesReducer(state = initialstate.trialBalances, action) {
	switch (action.type) {
		case types.GET_TRIAL_BALANCE:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				let trialBalances = [];

				action.response.map((tb) => {
					trialBalances.push({
						...tb,
						id: tb.id,
						trialBalanceTypeId: tb.trialBalanceTypeId,
						isCurrentVersion: tb.isCurrentVersion,
						currentPeriodDate: tb.currentperioddate,
						comparativePeriodDate: tb.comparativeperioddate,
						otherComparativePeriodDate: tb.othercomparativeperioddate
					});
				});

				return {
					...normalize(trialBalances, undefined, undefined, concatMergeStrategy),
					data: action.response
				};
			}
			return state;

		default:
			return state;
	}
}

export function trialBalanceByIdReducer(state = initialstate.trialBalance, action) {
	switch (action.type) {
		case types.GET_TRIAL_BALANCE_BY_ID:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				let trialBalance = [];

				action.response.map((tb) => {
					let financialStatements = tb.firstLevelFinancialStatements
						?.concat(tb.secondLevelFinancialStatements)
						?.concat(tb.thirdLevelFinancialStatements)
						?.concat(tb.fourthLevelFinancialStatements.data);

					let sortedClientData = [];
					if (tb.fifthLevelFinancialStatements?.data.length > 0) {
						sortedClientData = tb.fifthLevelFinancialStatements?.data.sort(Utility.sortByMultipleKey('glAccountName'));
					}

					const trailBalanceId = action?.payload?.accountId ? `${tb.id}_${action.payload.accountId}` : tb.id;

					trialBalance.push({
						...tb,
						id: trailBalanceId,
						accountId: action?.payload?.accountId,
						trialBalanceTypeId: tb.trialBalanceTypeId,
						isCurrentVersion: tb.isCurrentVersion,
						currentPeriodDate: tb.currentperioddate,
						comparativePeriodDate: tb.comparativeperioddate,
						otherComparativePeriodDate: tb.othercomparativeperioddate,
						financialStatement: financialStatements?.map((fs) => fs.id),
						financialStatementsTypes: financialStatements?.map((fs) => {
							return {id: fs.id, financialStatementTypeId: fs.financialStatementTypeId};
						}),
						clientData: sortedClientData
					});
				});

				const filterState = filterTrialBalancesState(state, action.includeArray);

				return {
					...normalize(trialBalance, undefined, filterState, concatMergeStrategy)
				};
			}
			return state;

		default:
			return state;
	}
}
